import { List } from '@mui/icons-material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import React from 'react'
import { useSelector } from 'react-redux/es/exports'
import { RootState } from '../../../../../app/store'
import { Box, Typography } from '@mui/material'
import NoRowsOverlay from '../../../../../shared/ui/NoRowsOverlay'

export const TimeSlotsCandidatesDialog = ({open,setOpen}:any) => {



  const timeSlotCandidates = useSelector(
    (state: RootState) => state.selectedTimeSlot?.usersPut || [],
  )

  const availabeScheduleCandidates = useSelector(
    (state: RootState) => state.AvailableScheduleCandidates || [],
  )
  
 const data = open.openCRUDTimeSlots.open
 ? timeSlotCandidates
 : availabeScheduleCandidates.candidates;
  
console.log(availabeScheduleCandidates,'availabeScheduleCandidates')

  return (
    <Dialog
    sx={{
      ".MuiDialog-paper": {
      
        px: "20px",
      },
      ".MuiDialogContent-root": {},
      ".MuiDialogActions-root": { px: "24px", pb: "40px" },
    }}
    maxWidth={"lg"}
    open={open.openCRUDTimeSlots.open  || open.openCreateAvailableSchedule.open }
    onClose={() => setOpen({ ...open, openCRUDTimeSlots: { open: false } })}
    keepMounted
    aria-describedby="alert-dialog-slide-description"
  >
   
      <DialogTitle sx={{ fontWeight: "bold", mt: "20px" }}>
      Кандидаты
      </DialogTitle>
      <DialogContent>
    
    
   { data.length ===0  ?  <Box   p={20} > <NoRowsOverlay/> </Box>
   :
   <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">

        
        <TableHead>
          <TableRow sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgb(55, 55, 55)"
            : "rgba(225, 225, 225, 1)",
                height: "57px",
                
            
      }}>
            <TableCell sx={{ fontSize: "14px",
             
             lineHeight: "1.2",
             fontWeight: "bold",
               }}>id</TableCell>
            <TableCell sx={{ fontSize: "14px",
             
             lineHeight: "1.2",
             fontWeight: "bold",
               }}>ФИО</TableCell>
                 { open.openCreateAvailableSchedule.open && <TableCell sx={{ fontSize: "14px",
             
             lineHeight: "1.2",
             fontWeight: "bold",
               }}>Статус</TableCell>}
                { open.openCreateAvailableSchedule.open && <TableCell sx={{ fontSize: "14px",
             
             lineHeight: "1.2",
             fontWeight: "bold",
               }}>Этап отсева</TableCell>}
          
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow
              key={row.name}
         
            >
              <TableCell >
                {row.id}
              </TableCell>
              <TableCell >{row.name}</TableCell>
             { open.openCreateAvailableSchedule.open && <TableCell >{row.status}</TableCell>}
             { open.openCreateAvailableSchedule.open && <TableCell >{row.eliminationStage }</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer> }
      </DialogContent>
      <DialogActions>
        <Stack
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
          direction="row"
          spacing={"10px"}
        >
          <Button
            size="large"
            sx={{ fontWeight: "bold" }}
            fullWidth
            variant="outlined"
            onClick={() => setOpen({ ...open, openCRUDTimeSlots: false , openCreateAvailableSchedule:false})}
          >
          Выйти
          </Button>
        
        </Stack>
      </DialogActions>
   
  </Dialog>
  )
}
